<template>
    <v-autocomplete
            :label="label"
            :items="items"
            :value="value"
            :multiple="multiple"
            :chips="chips"
            item-value="BM_GRUPO"
            item-text="BM_DESC"
            hide-details
            @input="actualizaValor($event)"
            @change="change($event)"
            clearable
            cache-items
            :readonly="readonly"
            :error-messages="errores.collect('familia')"
            :name="name"
            v-validate="validate"
            :filter="customFilter"
    >
        <template slot="item" slot-scope="data">
            <v-list-tile-content>
                <v-list-tile-title>{{ data.item.BM_DESC}}</v-list-tile-title>
                <v-list-tile-sub-title>
                    {{ data.item.BM_GRUPO }}
                </v-list-tile-sub-title>
            </v-list-tile-content>
        </template>
    </v-autocomplete>
</template>
<script>
    import mixinListas from '../mixins/items';

    export default {
        inject: ['$validator'],
        name: 'micro-grupo-select',
        props: ['multiple', 'value', 'chips', 'readonly', 'empresa', 'label', 'validate', 'name','label','preset'],
        mixins: [mixinListas],
        data() {
            return {
                items: []
            }
        },
        $_veeValidate: {
            value() {
                return this.value;
            }
        },
        watch: {
            preset(val) {
                this.items = (val && Object.keys(val).length !== 0) ? [val] : [];
            }
        },
        mounted() {
            this.itemMicroGrupo({empresa_id: this.empresa}, r => {
                this.items = r;
            }, err => {
                console.log(err)
            })
        },
        methods: {
            customFilter(item, queryText, itemText) {
                let desc = (item.BM_DESC) ? item.BM_DESC.toLowerCase().includes(queryText.toLowerCase()) : false;
                let cod = (item.BM_GRUPO) ? item.BM_GRUPO.toLowerCase().includes(queryText.toLowerCase()) : false;
                return (desc || cod);
            },
            actualizaValor(valor) {
                this.$emit('input', valor)
            },
            change(e) {
                this.$emit('change', e);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MicroGrupoSelect.vue